import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsfigure',
	templateUrl:'./BSFigurePage.html',
	styles: [],
	styleUrls:['./BSFigurePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSFigurePage
{
	mdContent_106 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.figures.BSFigure;
\`\`\``;
	mdContent_107 = `\`\`\`java
new BSFigure<>()
\`\`\``;
	mdContent_108 = `\`\`\`java
var figure = new BSFigure<>();
var img = new BSImage<>();
figure.add(img);
var caption = new BSFigureCaption<>();
caption.setText("A descriptive caption.");
figure.add(caption);
\`\`\``;
}
